var _desc, _defs, _use, _use2, _use3, _use4, _use5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMacbookTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "805px",
    height: "14px",
    viewBox: "0 0 805 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "top copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "107.956459%",
    y2: "99.2466518%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F4F9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CECBE4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "3.061617e-15%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8BFD5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F9",
    stopOpacity: 0.5,
    offset: "1.03728612%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4F1",
    stopOpacity: 0.5,
    offset: "1.98047158%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDCED",
    stopOpacity: 0.5,
    offset: "2.91709686%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F2F8",
    offset: "18.0457937%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCADD",
    stopOpacity: 0.60296066,
    offset: "94.6236262%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E4F1",
    stopOpacity: 0.570462189,
    offset: "96.2197128%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEFF",
    stopOpacity: 0.542792149,
    offset: "97.7042068%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F5FA",
    stopOpacity: 0.518340048,
    offset: "99.0160589%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A5CD",
    stopOpacity: 0.5,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 13.668 804.669983 13.668 804.669983 8 0 8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "105.613415%",
    y2: "97.0926418%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD8E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9992AF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 13.668 804.667 13.668 804.667 13 0 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.5 C0,5.194 25.958,7 48.5,7 C205.762159,7.66666667 323.595492,8 402,8 C480.854603,8 598.909937,7.66666667 756.166,7 C778.709,7 804.667,5.194 804.667,0.5 L0,0.5 Z",
    id: "path-6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "01_Homepage",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "top-copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-6"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-3"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-2)",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.25,
    fill: "#D1F9FF",
    style: {
      mixBlendMode: "color"
    },
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-6"
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-4)",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.25,
    fill: "#00BBD8",
    style: {
      mixBlendMode: "color"
    },
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-8",
    transform: "translate(402.333500, 4.250000) scale(1, -1) translate(-402.333500, -4.250000) "
  }, _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-4)",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.25,
    fill: "#D1F9FF",
    style: {
      mixBlendMode: "color"
    },
    xlinkHref: "#path-6"
  }), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.34,
    fill: "#FFFFFF",
    xlinkHref: "#path-6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacbookTop);
export default __webpack_public_path__ + "static/media/macbook-top.e0b4f5ea2dd6896c039377fff1c9d5ab.svg";
export { ForwardRef as ReactComponent };